import { Skeleton } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { formatWatchDuration, formatPercent } from './ContentActivityUtils';

const ContentActivitySummary = (props) => {
  const { summary, loading } = props;
  const trans = useSelector(translator);

  if (loading) {
    return (
      <div className="contentactivity-summary">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={`summary_skeleton_${index}`} className="stat-card">
            <Skeleton active paragraph={false} />
          </div>
        ))}
      </div>
    );
  }

  if (!summary || (summary.sessionCount === 0 && !summary.otherEngagementCount)) {
    return (
      <div className="contentactivity-empty-list-container">
        <div className="contentactivity-empty-list-label">{trans('NO_CONTENT_ACTIVITY')}</div>
      </div>
    );
  }

  const completionRateValue =
    summary.completionRate === null || summary.completionRate === undefined
      ? '—'
      : formatPercent(summary.completionRate * 100);

  const favoriteChannel = summary.favoriteChannel;

  const cards = [
    {
      key: 'totalWatch',
      title: trans('TOTAL_WATCH_TIME'),
      value: formatWatchDuration(summary.totalWatchMs),
      sub: null,
    },
    {
      key: 'sessions',
      title: trans('VIEWING_SESSIONS'),
      value: `${summary.sessionCount}`,
      sub: `${trans('ACTIVE_DAYS')}: ${summary.activeDays}`,
    },
    {
      key: 'completion',
      title: trans('COMPLETION_RATE'),
      value: completionRateValue,
      sub:
        summary.sessionCount > 0
          ? `${summary.completedCount} / ${summary.sessionCount} ${trans('COMPLETED')}`
          : null,
    },
    {
      key: 'favorite',
      title: trans('FAVORITE_CHANNEL'),
      value: favoriteChannel?.channelName || '—',
      sub: favoriteChannel ? formatWatchDuration(favoriteChannel.watchMs) : null,
    },
  ];

  return (
    <div className="contentactivity-summary">
      {cards.map((card) => (
        <div key={card.key} className="stat-card">
          <div className="stat-card-title">{card.title}</div>
          <div className="stat-card-value">{card.value}</div>
          {card.sub && <div className="stat-card-sub">{card.sub}</div>}
        </div>
      ))}
    </div>
  );
};

ContentActivitySummary.propTypes = {
  summary: PropTypes.shape({
    totalWatchMs: PropTypes.number,
    sessionCount: PropTypes.number,
    completionRate: PropTypes.number,
    completedCount: PropTypes.number,
    abandonedCount: PropTypes.number,
    activeDays: PropTypes.number,
    avgSessionMs: PropTypes.number,
    otherEngagementCount: PropTypes.number,
    favoriteChannel: PropTypes.shape({
      channelId: PropTypes.string,
      channelName: PropTypes.string,
      watchMs: PropTypes.number,
    }),
  }),
  loading: PropTypes.bool,
};

export default ContentActivitySummary;
